import { z } from 'zod';

export const CoreShortLinkScalarFieldEnumSchema = z.enum(['id','cityId','domain','knownLinkType','knownLinkId','longURL','longURLHash','createdAt','updatedAt']);

export default CoreShortLinkScalarFieldEnumSchema;
